import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=7b8e705e&scoped=true"
import script from "./AlertsTable.vue?vue&type=script&lang=js"
export * from "./AlertsTable.vue?vue&type=script&lang=js"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=7b8e705e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e705e",
  null
  
)

export default component.exports